// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__TQ","cls2":"ResearchInterestTags-cls2_pnv ResearchInterestTags-cls1__TQ"};